export default __webpack_public_path__ + "static/media/universityLoginCover.d77d7c95.png";